module.exports = __webpack_public_path__ + "img/kr-product-final-card2-img1.2cca679.png";